import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ManageUser from '../views/ManageUser.vue'
import ManageGroup from '../views/ManageGroup.vue'
import ManageCalendar from '../views/ManageCalendar.vue'
import CalendarPublisher from '../views/CalendarPublisher.vue'
import MyCalendar from '../views/MyCalendar.vue'
import Guide from '../views/Guide.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/my-cal',
    name: 'MyCalendar',
    component: MyCalendar
  },  
  {
    path: '/cal-publisher',
    name: 'CalendarPublisher',
    component: CalendarPublisher
  },
  {
    path: '/manage-user',
    name: 'ManageUser',
    component: ManageUser
  },
  {
    path: '/manage-group',
    name: 'ManageGroup',
    component: ManageGroup
  },
  {
    path: '/manage-cal',
    name: 'ManageCalendar',
    component: ManageCalendar
  },
  {
    path: '/help',
    name: 'Guide',
    component: Guide
  },
  {
    path: '*',
    name: 'Home',
    component: Home
  }, 
]

const router = new VueRouter({
  routes
})

export default router
